// extracted by mini-css-extract-plugin
export var copyIcon = "_re-2";
export var discountCard = "_re-0";
export var discountCode = "_re-3";
export var discountContent = "_re-1";
export var loadingCard = "_re-4";